import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
import MBSJLogo from "../assets/img/clients/mbsj-logo.png"
import UMLogo from "../assets/img/clients/um-logo.png";
import URBANLogo from "../assets/img/clients/urban-logo.png";
import HKLogo from "../assets/img/logo.png";
import ClientLogo05 from "../assets/img/clients/logo05.svg";
import ClientLogo06 from "../assets/img/clients/logo06.svg";

export default function ClientSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter mbsj-logo">
          <ImgStyle src={MBSJLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter um-logo">
          <ImgStyle src={UMLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter urban-logo">
          <ImgStyle src={URBANLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter hk-logo">
          <ImgStyle src={HKLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter mbsj-logo">
          <ImgStyle src={MBSJLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter um-logo">
          <ImgStyle src={UMLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter urban-logo">
          <ImgStyle src={URBANLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter hk-logo">
          <ImgStyle src={HKLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter mbsj-logo">
          <ImgStyle src={MBSJLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter um-logo">
          <ImgStyle src={UMLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter urban-logo">
          <ImgStyle src={URBANLogo} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter hk-logo">
          <ImgStyle src={HKLogo} alt="client logo" />
        </LogoWrapper>
        
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  height: 100px;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;

const ImgStyle = styled.img`
  height: 100%;
  padding: 10%;
`;